import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { cmsApiRequest } from "../../Lib/Utils/ApiRequest";
import { getLocaleFromCookie } from "../../Lib/Utils/getLocaleFromCookie";
import { IApiResponse, ICmsConfirmationContent } from "../../Orchestrator/Types/Index";

export async function getCmsConfirmationPopupContent(slug: string, showLoader = false): Promise<IApiResponse<ICmsConfirmationContent>> {
  const ENDPOINTS = await getEndpoints();
  const endpoint = ENDPOINTS.getConfirmationContentAPI;

  const params = new URLSearchParams();
  const locale = await getLocaleFromCookie();

  params.append("filters[slug][$eq]", slug);
  params.append("locale", locale);

  let endpointWithParams = `${endpoint}?${params.toString()}`;
  return await cmsApiRequest<ICmsConfirmationContent>(endpointWithParams, "GET", {}, showLoader);
}